module.exports = __webpack_public_path__ + "img/pitrera_village.15a304ac.jpg";